import React from "react";
import { MusicHallAndPracticeInfoContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { withTranslation } from "react-i18next";
import { userService } from "apiServices";
import { ROUTE_PATH } from "utils/constants/routePath";
import { Cards, Displays, Navigations } from "components";

class MusicHallAndPracticeInfoContainer extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    const { router } = this.props;
    let res = await userService.GET_ROOM_BOOKING_DETAIL(router.params.id);
    if (res && res.status === 200) {
      this.setState({
        data: res.data,
        isLoading: false,
      });
    }
  };

  render() {
    const { t } = this.props;
    const { isLoading, data } = this.state;
    const DATE_BREADCRUMB = [
      {
        name: t("Home", { ns: "common" }),
        path: ROUTE_PATH.HOME,
      },
      {
        name: t("Music Practice Room", { ns: "common" }),
        path: `${ROUTE_PATH.MUSIC_PRACTICE_ROOM}`,
      },
    ];
    return (
      <MusicHallAndPracticeInfoContainerStyled>
        <div className="breadcrumb_layout">
          <Navigations.Breadcrumb data={DATE_BREADCRUMB} />
        </div>
        <div className="music_practice_container">
          {isLoading ? (
            <Displays.Loading />
          ) : (
            <Cards.BookingDetailInfo {...data} />
          )}
        </div>
      </MusicHallAndPracticeInfoContainerStyled>
    );
  }
}

export default withTranslation(["common"])(
  withRouter(MusicHallAndPracticeInfoContainer),
);
